import React, { useEffect, useState } from "react";
import "./loginComponent.css";
import loginLogo from "../../assets/images/newLogo.png";
import LoginInputs from "../../commanComponents/inputs/LoginInputs";
import svgData from "../../constants/utilities/svgData";
import ColorBtn from "../../commanComponents/buttons/ColorBtn";
import { useNavigate } from "react-router-dom";
import OTPInput from "react-otp-input";
import { communication } from "../../constants/apis/communication";
import { useMutation, useQuery } from "react-query";
import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import Loader from "../../commanComponents/Loader";

export default function ResetPassword() {
  const [captcha, setCaptcha] = useState(generateCaptcha());
  const [captchaInput, setCaptchaInput] = useState("");
  const [invalidCaptcha, setInvalidCaptcha] = useState(false);
  const navigate = useNavigate();
  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const { mutate, isLoading } = useMutation((data) => communication?.resetPassword(data), {
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      if (data?.data?.status == "SUCCESS") {
        toast.success(`Success:  ${data?.data?.message}`);
        navigate(`/login?page=otp&userId=${getValues("userId")}`);
      } else {
        toast.error(`Failed : ${data?.data?.message}`);
      }
    },
    onError: (error) => {
      toast.error(`Failed to update status: ${error?.message}`);
    },
  });

  function generateCaptcha() {
    const chars = "0123456789abcdefghijklmnopqrstuvwxyz";
    let text = "";
    for (let i = 0; i < 6; i++) {
      text += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return text;
  }

  const handleResetPassword = (data) => {
    if (!captchaInput) {
      setInvalidCaptcha("Capcha is required");
      return;
    }
    if (captchaInput !== captcha) {
      toast.error("Invalid Capcha");
      return;
    }
    mutate(data);
  };

  return (
    <>
      {isLoading && <Loader />}
      <div className="loginComponent">
        <div className="loginLeft">
          <div className="logoContainer">
            <img src={loginLogo} alt="MOIL Logo" />
            <h1>MOIL LIMITED</h1>
            <p>( A Government of India Enterprise )</p>
          </div>
        </div>

        <div className="loginRight">
          <div className="loginFormContainer">
            <div className="centeredFormHeader">
              <span>{svgData?.resetPasswordIcon}</span>
              <h2>Reset Password</h2>
            </div>

            <form
              className="d-flex flex-column gap-4"
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit(handleResetPassword)();
              }}
            >
              <LoginInputs
                placeholder={"User ID"}
                icon={svgData?.profileIcon}
                register={{ ...register("userId", { required: "User Id is Required" }) }}
                errorMessage={errors?.userId}
                style={{ backgroundColor: "transparent" }}
              />

              <div className="captchaContainer">
                <div className="captchaWrapper">
                  <div className="captchaBox">{captcha}</div>
                  <div
                    className="captchaReload"
                    onClick={() => {
                      setCaptcha(generateCaptcha());
                    }}
                  >
                    {svgData?.reloadIcon}
                  </div>
                  <div className="captchaInputContainer">
                    <input
                      placeholder="Enter Captcha"
                      value={captchaInput}
                      onChange={(e) => {
                        setCaptchaInput(e.target.value);
                        setInvalidCaptcha(false);
                      }}
                    />
                  </div>
                </div>
                {invalidCaptcha && (
                  <div className="captchaErrorWrapper">
                    <div className="captchaError">
                      <span className="errorIcon">&times;</span>
                      <span>Invalid Captcha</span>
                    </div>
                  </div>
                )}
              </div>

              <div className="formLinks">
                <p
                  onClick={() => {
                    navigate("/login");
                  }}
                >
                  Back to Login?
                </p>
              </div>

              <ColorBtn
                text={"Next"}
                bgColor="#2F3299"
                color="#fff"
                style={{
                  boxShadow: "0px 4px 4px 0px #00000040",
                  border: "none",
                  width: "100%",
                  padding: "12px",
                  borderRadius: "6px",
                  fontSize: "16px",
                  fontWeight: "600",
                  marginTop: "10px",
                }}
              />
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
